






























































import { Component, Vue, Prop } from 'vue-property-decorator';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import InfoIcon from '@/components/icons/InfoV2.vue';

import { Dropdown } from '@/components/molecules';
import { getRenewedValue } from '@/models/offer';
import { TextField } from '@/components/atoms';

@Component({
  components: {
    Typography,
    InfoIcon,
    TextField,
    Dropdown
  }
})
export default class RenewalFrequency extends Vue {
  @Prop() value!: any;
  @Prop() disabled?: boolean;
  @Prop() error?: boolean;

  period = getRenewedValue(this.value).period;
  time = getRenewedValue(this.value).time;

  maxValuesPerPeriod: any = {
    yearly: 1,
    monthly: 12,
    weekly: 52
  };

  get tPrefix() {
    return 'offers.form.renewedRule';
  }

  get initialValueDropdown() {
    if (this.value)
      return this.dropdownValues.filter(
        item => item.value === getRenewedValue(this.value).period
      )[0].label;
    return 'Year';
  }

  get maxInput() {
    return `${this.maxValuesPerPeriod[this.period]}`;
  }

  get dropdownValues() {
    return [
      {
        label: 'Week',
        value: 'weekly',
        disabled: this.time > this.maxValuesPerPeriod['weekly']
      },
      {
        label: 'Month',
        value: 'monthly',
        disabled: this.time > this.maxValuesPerPeriod['monthly']
      },
      {
        label: 'Year',
        value: 'yearly',
        disabled: this.time > this.maxValuesPerPeriod['yearly']
      }
    ];
  }

  changeTime(time: string) {
    let timeValue = time;

    if (Number(timeValue) > Number(this.maxInput))
      timeValue = `${this.maxInput}`;

    this.time = timeValue;

    this.$emit('input', `${this.period}:${timeValue}`);
  }

  changePeriod(period: string) {
    this.period = period;
    if (period === 'yearly') this.time = '1';
    this.$emit('input', `${period}:${this.time}`);
  }
}
